<template>
  <div id="modalCreateEditModule" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Módulo</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.module.name.$errors.length }"
                  placeholder="Nome do Módulo"
                  v-model="v$.module.name.$model"
                />
                <span
                  v-if="v$.module.name.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.module.name.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O nome deve possuir pelo menos
                  {{ v$.module.name.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Descrição: <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  :class="{
                    'is-invalid': v$.module.description.$errors.length,
                  }"
                  placeholder="Descrição do Módulo"
                  rows="4"
                  v-model="v$.module.description.$model"
                />
                <span
                  v-if="v$.module.description.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditModuleModal',

  props: {
    courseId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      module: {
        name: '',
        description: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.moduleId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getModule() {
      try {
        this.module = await this.$store.dispatch('getModule', {
          courseId: this.courseId,
          moduleId: this.moduleId,
        })
        showModal('modalCreateEditModule')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.moduleId) {
            response = await this.$store.dispatch('updateModule', {
              courseId: this.courseId,
              moduleId: this.moduleId,
              module: this.module,
            })
          } else {
            response = await this.$store.dispatch('saveModule', {
              courseId: this.courseId,
              module: this.module,
            })
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      module: {
        name: {
          required,
          minLength: minLength(4),
        },
        description: {
          required,
        },
      },
    }
  },

  mounted() {
    if (this.moduleId) {
      this.getModule()
    } else {
      showModal('modalCreateEditModule')
    }
  },
}
</script>
